import { Component, OnInit, computed, effect, inject, input } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ReferenceMeasurementItemLengthComponent } from "@components/reference-measurement-item-length/reference-measurement-item-length.component";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { MeasurementLine } from "@domain/project/floorplan/measurement-line";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";

@Component({
  selector: "app-measurement-line-notes",
  templateUrl: "./measurement-line-notes.component.html",
  styleUrl: "./measurement-line-notes.component.scss",
  imports: [UiKitModule, ReactiveFormsModule, FloorplanItemDetailsComponent, ReferenceMeasurementItemLengthComponent],
  standalone: true,
})
export class MeasurementLineNotesComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);

  readonly floorplanItem = input.required<FloorplanItem>();
  protected readonly measurementLine = computed(() => this.floorplanItem() as MeasurementLine);

  protected measurementLineForm?: FormGroup;

  constructor() {
    effect(() => {
      const measurementLine = this.measurementLine();
      this.measurementLineForm?.reset({ text: measurementLine.text }, { emitEvent: false });
    });
  }

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.measurementLineForm = this.formBuilder.group({
      text: [this.measurementLine().text, Validators.required],
    });

    this.measurementLineForm.valueChanges.subscribe(() => {
      if (!this.measurementLineForm!.valid || this.measurementLineForm!.pristine) return;
      this.update();
    });
  }

  private update() {
    this.measurementLine().text = this.measurementLineForm!.value.text;
  }
}
